import AudioVideoWrapper from 'components/AudioVideoWrapper';
import ChatWrapper from 'components/ChatWrapper';
import CheckPermissions from 'components/CheckPermissions';
import LoadingSpinner from 'components/LoadingSpinner';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import * as userActions from '../../store/user/userActions';
import AttendeeView from './attendee-view/index';
import PresenterView from './presenter-view/index';

const Index = () => {
  const audioElement = useRef(null);
  const [hasCheckedPermissions, setHasCheckedPermissions] = useState(false);
  const queryRef = new URLSearchParams(useLocation().search);
  const query = useRef(queryRef);
  const dispatch = useDispatch();
  const { role } = useSelector(({ user }) => ({
    role: user.role,
  }));
  const isPresenter = role === 'admin' || role === 'presenter';

  useEffect(() => {
    const token = query.current.get('token');
    localStorage.clear();
    localStorage.setItem('conference-token', btoa(token));
    // removeTokenFromQuery();
    dispatch(
      userActions.initializeConferenceTokenAction({
        cmsToken: token,
        audioRef: audioElement.current,
      })
    );
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {isPresenter && (
        <AudioVideoWrapper>
          <ChatWrapper>
            <CheckPermissions
              hasCheckedPermissions={hasCheckedPermissions}
              setHasCheckedPermissions={setHasCheckedPermissions}
            />
            {hasCheckedPermissions && <PresenterView />}
          </ChatWrapper>
        </AudioVideoWrapper>
      )}
      {role === 'attendee' && <AttendeeView />}
      {!role && <LoadingSpinner />}
      <audio ref={audioElement} style={{ display: 'none' }} />
    </>
  );
};

export default Index;
